import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Filtros from "@Composicion/Filtros/Filtros";
import VisorPDF from "@Utilitarios/VisorPDF/VisorPDF";

// import MAgregarProducto from "@MPDFSolicitudEntrega/Modales/MAgregarProducto";
// import MGenerarPedido from "@MPDFSolicitudEntrega/Modales/MGenerarPedido";

import "./MPDFSolicitudEntrega.css";

function MPDFSolicitudEntrega({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);

  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},
    da_reglasDeEstadoRegistros: [],
    d_fechaPdf: _f_.fechaActual({
      formato: "yyyy-mm-dd",
    }),
    d_verPdf: false,
    d_pdfBase64: "",
    d_verModalGenerarPedido: false,
    d_esperandoProcesoTabla: false,
  });

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento);
    let llamadoAPI = {};
    if (parametros?.pdfSeleccionado == "pdfsolicitud") {
      llamadoAPI = _api_.f_reportePedidoProduccionDiario({
        parametros: {
          fecha: v_u.d_fechaPdf,
        },
        timeout: 20000,
        origen: origenComponente,
      });
    }
    llamadoAPI?.respuesta?.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u,{d_pdfBase64:dPC.contenido.reporte})
      }
    });
  }, [recargaComponente, v_u.d_fechaPdf]);
  return (
    <div className={"MPDFSolicitudEntregaCSS-contenedor"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false });
            _f_.asignar(ev_u, { d_verPdf: false, d_verModalGenerarPedido: false });
          }}></ModalInformacion>
      )}
      {/* <div className="titulo-componente">{"Generar Pedido de Producción"}</div> */}
      {/* <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      /> */}
      <div className={"MPDFSolicitudEntregaCSS-fechas"}>
        <_ipt_.Input4
          tipo={"date"}
          texto={`Fecha`}
          defaultValue={_f_.fechaActual({
            formato: "yyyy-mm-dd",
          })}
          onBlur={(evento)=>{
            console.log(evento.target.value)
            _f_.asignar(ev_u,{d_fechaPdf:evento.target.value})
          }}
        />
      </div>

      <VisorPDF
        id="mi-pdf"
        titulo="PDF"
        base64={v_u.d_pdfBase64}
        //d_fechaPdf
        nombreArchivo={`PedidoDistribucion_${0}_${_f_.formatearFecha({valor:v_u.d_fechaPdf, formato: "dd_mm_yyyy" })}_${_f_.horaActual({ formato: "hh_mm_ss" })}.pdf`}
        autoDownload={false}
        modoImpresion={esComputadora ? "sistema" : "ventana"}
      />
      {/* <div className="MPDFSolicitudEntregaCSS-opciones">
        
      </div> */}
    </div>
  );
}

export default MPDFSolicitudEntrega;
